import { render } from "./OtherHeaderComponent.vue?vue&type=template&id=9894ad28"
import script from "./OtherHeaderComponent.vue?vue&type=script&lang=js"
export * from "./OtherHeaderComponent.vue?vue&type=script&lang=js"

import "./OtherHeaderComponent.vue?vue&type=style&index=0&id=9894ad28&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__